import { render, staticRenderFns } from "./ProjectDeliverableList.vue?vue&type=template&id=06fe071d&"
import script from "./ProjectDeliverableList.vue?vue&type=script&lang=js&"
export * from "./ProjectDeliverableList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports